import React, { useContext } from 'react';
import { usePrefs, useLabels } from 'wsm-common-data';
import { setClassNames } from '@ddc/classnames-js';
import { ResultsContext } from '../contexts';
import { g } from '../global-constants';

const NoResults = () => {
	const { didRequestTimeout, requestTimeoutType } =
		useContext(ResultsContext);
	const labels = useLabels();
	const { display } = usePrefs();
	const isPanelMode = display === g.NAVIGATION_DRAWER;

	const messageClassName = setClassNames([
		'p-4',
		isPanelMode ? 'sts-panel-no-results' : 'text-body'
	]);

	let message = labels.get('SORRY_NO_RESULTS');

	if (didRequestTimeout) {
		const fallbackLabel = labels.get('SORRY_TIMEOUT_GENERIC');

		switch (requestTimeoutType) {
			case 'add': {
				message = labels.get('SORRY_TIMEOUT_ADD');
				break;
			}
			case 'inventory': {
				message = labels.get('SORRY_TIMEOUT_INVENTORY');
				break;
			}
			case 'pages': {
				message = labels.get('SORRY_TIMEOUT_PAGES');
				break;
			}
			default: {
				message = labels.get('SORRY_TIMEOUT_GENERIC');
				break;
			}
		}

		// Handle any undefined labels
		message = message || fallbackLabel;
	}

	return (
		<div
			data-testid="sts-no-results"
			aria-live="polite"
			aria-atomic="true"
			role="alert"
		>
			<div
				data-testid="sts-no-results-message"
				className={messageClassName}
			>
				<strong>{message}...</strong>
			</div>
		</div>
	);
};

export default NoResults;
